import { useState } from 'react';
import fuzzy from 'fuzzy';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import { convertWebhookToEventTriggerOption } from 'automation-ui-enrollment/utils/webhookUtils';
import WebhookManagementView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookManagementView';
import WebhookWizard from 'automation-ui-enrollment/components/eventEnrollment/WebhookWizard';
import WebhookTriggersEmptyState from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookTriggersEmptyState';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import { areWebhookTriggersAllowedForObjectType } from 'automation-ui-enrollment/hooks/useHasWebhookTriggersAccess';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WebhookSelectionPanel({
  webhookTriggerOptions,
  onClose,
  onSelectTriggerOption
}) {
  const [shouldShowWebhookManagement, setShouldShowWebhookManagement] = useState(false);
  const [shouldShowWebhookWizard, setShouldShowWebhookWizard] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const {
    isLocked,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs({
    objectTypeFilter: areWebhookTriggersAllowedForObjectType
  });
  const isEmpty = webhookTriggerOptions.length === 0;
  const webhookOptionSearchResults = fuzzy.filter(searchTerm, webhookTriggerOptions, {
    extract: ({
      text
    }) => text
  }).sort(({
    score: scoreA
  }, {
    score: scoreB
  }) => scoreB - scoreA).map(({
    original
  }) => {
    var _original$supportedOb;
    return Object.assign({}, original, {
      locked: isLocked((_original$supportedOb = original.supportedObjectTypeIds[0]) !== null && _original$supportedOb !== void 0 ? _original$supportedOb : '')
    });
  });
  const handleSelectWebhook = webhook => {
    if (shouldSelectObjectType(webhook.objectTypeId)) {
      onSelectTriggerOption(Object.assign({
        type: 'EVENT'
      }, convertWebhookToEventTriggerOption(webhook)));
    }
  };
  const handleSelectTriggerOption = triggerOption => {
    var _triggerOption$suppor;
    if (shouldSelectObjectType((_triggerOption$suppor = triggerOption.supportedObjectTypeIds[0]) !== null && _triggerOption$suppor !== void 0 ? _triggerOption$suppor : '')) {
      onSelectTriggerOption(triggerOption);
    }
  };
  if (shouldShowWebhookManagement) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIBackButton, {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.backToTriggerTypeSelection"
          })
        })
      }), /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.webhookSelectionPanel.manageWebhooks.title"
        })
      }), /*#__PURE__*/_jsx(WebhookManagementView, {
        onSelectWebhook: handleSelectWebhook
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
        onClose: onCloseCustomModal
      }), shouldShowWebhookWizard && /*#__PURE__*/_jsx(WebhookWizard, {
        onClose: () => setShouldShowWebhookWizard(false)
      }), /*#__PURE__*/_jsx(SelectionPanel, {
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.webhookSelectionPanel.title"
        }),
        options: webhookOptionSearchResults,
        searchTerm: searchTerm,
        onSearchTermChange: setSearchTerm,
        onClose: onClose,
        onSelectOption: handleSelectTriggerOption,
        headingAction: isEmpty ? /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: () => setShouldShowWebhookWizard(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.webhookSelectionPanel.addWebhookLink"
          })
        }) : /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: () => setShouldShowWebhookManagement(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.webhookSelectionPanel.manageWebhooksLink"
          })
        }),
        emptyState: /*#__PURE__*/_jsx(WebhookTriggersEmptyState, {
          setShowWizard: setShouldShowWebhookWizard
        })
      })]
    });
  }
}